import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetStockListPagingAndFilterRequest } from '../models/request/stock/GetStockListPagingAndFilterRequest';
import { AddStockRequest } from '../models/request/stock/AddStockRequest';

export class StockService {
    static async getStockList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getStockList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Stock/getStockList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportStockList(inputObj: GetStockListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportStockList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Stock/exportStockList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getStockListPagingAndFilter(inputObj: GetStockListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetStockListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Stock/GetStockListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addStock(inputObj: AddStockRequest) {
        try {
            console.log('SERVICE CALL - AddStock', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Stock/AddStock', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteStock(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteStock', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Stock/deleteStock', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getStockById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getStockById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Stock/getStockById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}